export enum CookieKey {
  jwt = 'jwt',
  ip_access = 'ip_access',
  orderCode = 'ocE4kj3R',
}
